<template>
  <div class="col-6 u-pull-left ignore-screen">
    <div class="pagination">
      <div class="pagination-item short">
        <a
          v-bind:disabled="pages.previous == null"
          v-on:click="$emit('handlePage', pages.previous)"
          href="#"
          class=""
          >Prev</a
        >
      </div>
      <div v-for="(num, idx) in getRange()" :key="`pg-${idx}`">
        <div class="pagination-item short" :class="{ selected: num == page() }">
          <a v-on:click="$emit('handlePage', num)" href="#" class="">
            {{ num }}
          </a>
        </div>
      </div>
      <div class="pagination-item short">
        <a
          v-bind:disabled="pages.next == null"
          v-on:click="$emit('handlePage', pages.next)"
          href="#"
          class=""
          >Next</a
        >
      </div>
    </div>
  </div>
</template>
<style>
.pagination {
  margin-bottom: 1rem;
}
</style>
<script>
export default {
  name: "pagination-links",
  props: ["pages"],
  methods: {
    getRange() {
      const thisPage = this.$route.query.page;
      const n = 3;
      var maxPage = Number;
      var minPage = Number;
      if (!thisPage) {
        // Set default values if on the first page
        minPage = 1;
        maxPage = Math.min(this.pages.last, n);
      } else {
        // Set normal limits to +/- n pages
        minPage = Math.max(1, thisPage - n);
        maxPage = Math.min(this.pages.last, thisPage + n);
      }
      if (thisPage < n - 1 || thisPage == undefined) {
        // For early pages do this to stop the range growing incrementally
        // with each click
        maxPage = Math.min(this.pages.last, minPage + n);
      }
      var arr = [];
      for (let step = minPage - 1; step < maxPage; step++) {
        arr.push(step + 1);
      }
      return arr;
    },
    page() {
      var page = this.$route.query.page;
      if (!page) {
        page = 1;
      }
      return page;
    }
  },
  watch: {
    pages() {
      this.page();
      this.getRange();
    }
  }
};
</script>
